import { Typography } from "@material-ui/core"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"
import {
  StyledBody,
  StyledHeaderH2,
  StyledLi,
  StyledLink,
  StyledSmallText,
  StyledSubtitle,
  StyledTable,
  StyledTd,
  StyledTh,
  StyledThead,
  StyledTr,
  StyledUl,
} from "../../reusable/wrappers/BodyText"
import CenterText from "../../reusable/wrappers/CenterText"
import ImageContainer from "../../reusable/wrappers/ImageContainer"

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  max-width: 1160px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 0px;
    max-width: 100%;
    width: 100%;
    div,
    p,
    ul {
      padding-left: 20px;
    }
    h2 {
      width: 320px;
    }
    li {
      width: 320px;
      font-size: 18px;
    }
    a {
      width: 250px;
    }
  }
`
const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
  td:first-child {
    font-size: 18px;
  }
`

const StyledH2 = styled(Typography).attrs({
  variant: "h2",
})<{ $margin?: number; $fontWeight?: string; $fontSize?: string }>`
  font-size: ${(p) => (p.$fontSize ? p.$fontSize : "20px")};
  margin-top: ${(p) => p.$margin && p.$margin}px;
  font-weight: ${(p) => (p.$fontWeight ? p.$fontWeight : "bold")};
`

const StyledHyperlink = styled.a`
  color: #101010;
  font-size: 18px;
  font-family: MazdaType, OENaPro, sans-serif;
  line-height: 150%;
  text-decoration: underline;
`

const StyledSmallTextP = styled(Typography).attrs({ variant: "body1" })<{}>`
  font-size: 14px;
  margin-top: 10px;
`

const AccessibilityPage = () => {
  const headerText = [
    'דלק מוטורס בע"מ משקיעה מאמצים ומשאבים רבים כדי לספק שירות נגיש, שוויוני ומכבד לכל אחד ואחת מהלקוחות שלנו. בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות תשנ״ח-1998, ביצענו התאמות נגישות באולמות התצוגה שלנו כדי לאפשר לכל אדם לקבל שירות שוויוני ברמה הגבוהה ביותר. כאן ניתן להתעדכן בהסדרי הנגישות בכל אולם',
  ]
  const isDesktop = useIsDesktop()

  return (
    <StyledPageWrapper $padding={"0px"}>
      <StyledPageDiv>
        <ImageContainer
          src={
            isDesktop
              ? "/img/accessibility.jpg"
              : "/img/accessibilityMobile.jpg"
          }
        />
        <BreadCrumbsWrapper name="Accessibility" />
        <StyledTextWrapp>
          <CenterText title="הצהרת נגישות" headerText={headerText} withBorder />
          <StyledHeaderH2 $margin={40}>הסדרי נגישות מבנים</StyledHeaderH2>
          <StyledSmallText>
            להלן הסדרי הנגישות הקיימים במרכזי קבלת קהל
          </StyledSmallText>
          <StyledTable $width={"auto"}>
            <StyledThead>
              <StyledTr>
                <StyledTh style={{ minWidth: "190px" }}>
                  מרכזי קבלת קהל
                </StyledTh>
                <StyledTh style={{ minWidth: "260px" }}>כתובת</StyledTh>
                <StyledTh style={{ minWidth: "109px" }}>מצב נגישות</StyledTh>
                <StyledTh style={{ minWidth: "105px" }}>חניות נכים</StyledTh>
                <StyledTh style={{ minWidth: "150px" }}>
                  שירותים נגישים
                </StyledTh>
                <StyledTh style={{ minWidth: "122px" }}>שילוט הכוונה</StyledTh>
              </StyledTr>
            </StyledThead>

            <StyledTr>
              <StyledTd>משרדי החברה</StyledTd>
              <StyledTd>א.ת ניר צבי</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>מוסך מרכזי</StyledTd>
              <StyledTd>א.ת ניר צבי</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>אולם מאזדה חיפה</StyledTd>
              <StyledTd>שד׳ הסתדרות 50, חיפה</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>אולם מאזדה ירושלים</StyledTd>
              <StyledTd>רח׳ פייר קניג 40, ירושלים</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>אולם מאזדה רעננה</StyledTd>
              <StyledTd>רח׳ תדהר 2, רעננה</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>אולם מאזדה ת״א</StyledTd>
              <StyledTd>רח׳ החרש 20, ת״א</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>
          </StyledTable>
          <StyledSmallText $margin={40}>
            להלן הסדרי הנגישות הקיימים בסוכנויות המשנה
          </StyledSmallText>

          <StyledTable $width={"auto"}>
            <StyledThead>
              <StyledTr>
                <StyledTh style={{ minWidth: "190px" }}>
                  מרכזי קבלת קהל
                </StyledTh>
                <StyledTh style={{ minWidth: "260px" }}>כתובת</StyledTh>
                <StyledTh style={{ minWidth: "109px" }}>מצב נגישות</StyledTh>
                <StyledTh style={{ minWidth: "105px" }}>חניות נכים</StyledTh>
                <StyledTh style={{ minWidth: "150px" }}>
                  שירותים נגישים
                </StyledTh>
                <StyledTh style={{ minWidth: "122px" }}>שילוט הכוונה</StyledTh>
              </StyledTr>
            </StyledThead>

            <StyledTr>
              <StyledTd>מאזדה נצרת</StyledTd>
              <StyledTd>{`רח' פאולוס השישי 42, נצרת`}</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>בהליך הנגשה</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>מאזדה חיפה</StyledTd>
              <StyledTd>{`רח' יפו 124, חיפה`}</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>מאזדה נתניה</StyledTd>
              <StyledTd>{`רח' דוד פנקס 36, נתניה`}</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>מאזדה אשדוד</StyledTd>
              <StyledTd>{`רח' הורגנים 11, אשדוד`}</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>

            <StyledTr>
              <StyledTd>אולם מאזדה באר-שבע</StyledTd>
              <StyledTd>{`רח' עמל 2, באר שבע`}</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>נגיש</StyledTd>
              <StyledTd>בהליך הנגשה</StyledTd>
              <StyledTd>נגיש</StyledTd>
            </StyledTr>
          </StyledTable>
          <StyledHeaderH2 $margin={40}>מרכזי שירות</StyledHeaderH2>
          <StyledBody>
            מרכזי השירות הם גופים עצמאיים האחראים לעמידה בדרישות הנגישות של
            מתקניהם ואתריהם. על לקוח עם מוגבלות המבקש לקבל שירות במרכז שירות
            מסוים, ליצור קשר עם מרכז השירות לקבלת מידע בנושא הנגישות
          </StyledBody>

          <StyledHeaderH2 $margin={40}>שירות לקוחות נגיש</StyledHeaderH2>
          <StyledSmallText $margin={20}>
            הדרכות עובדים לשירות נגיש
          </StyledSmallText>
          <StyledBody>
            מתקיימות הדרכות להכרת תחום הנגישות, יצירת מודעות בקרב העובדים
            והקניית כלים מעשיים למתן שירות נגיש.
          </StyledBody>
          <StyledSmallText $margin={20}>מוקד טלפוני נגיש </StyledSmallText>
          <StyledBody>
            המענה הקולי הונגש כך שהמידע מועבר בשפה ברורה וללא מוסיקת רקע.
          </StyledBody>
          <StyledSmallText $margin={20}>
            אמצעים נוספים ליצירת קשר
          </StyledSmallText>
          <StyledBody>
            דוא״ל:{" "}
            <StyledLink
              href="mailto: s.uzon@delekmotors.co.il"
              $color="#4C607E"
              $fontSize={18}
            >
              s.uzon@delekmotors.co.il
            </StyledLink>
          </StyledBody>
          <StyledBody>
            פניה באמצעות "צור קשר" באתר. לנוחיותכם לינק{" "}
            <StyledHyperlink href="contact-us">לטופס פנייה</StyledHyperlink>{" "}
            {">"}
          </StyledBody>
          <StyledBody>
            פניה באמצעות הדואר: אזור תעשייה מושב ניר צבי, ת.ד 200, 7290500
          </StyledBody>

          <StyledHeaderH2 $margin={40}>נגישות אתר האינטרנט</StyledHeaderH2>
          <StyledBody>
            {` אתר אינטרנט נגיש הוא אתר המאפשר לאנשים עם מוגבלות ולאנשים מבוגרים
            לגלוש באותה רמה של יעילות והנאה ככל הגולשים, כ- 20 עד 25 אחוזים
            מהאוכלוסייה נתקלים בקשיי שימוש באינטרנט ועשויים להיטיב מתכני אינטרנט
            נגישים יותר, כך על פי מחקר שנערך בשנת 2003 ע"י חברת מייקרוסופט. חברת
            דלק מוטורס בע"מ מאמינה ופועלת למען שוויון הזדמנויות במרחב האינטרנטי
            לבעלי לקויות מגוונות ואנשים הנעזרים בטכנולוגיה מסייעת לשימוש במחשב.`}
          </StyledBody>
          <StyledSubtitle $margin={20} $fontWeight={"300"}>
            מידע על נגישות האתר
          </StyledSubtitle>
          <StyledUl $padding={1}>
            <StyledLi $margin={20}>
              {`אתר זה עומד בדרישות תקנות שיוויון זכויות לאנשים עם מוגבלות (התאמות
              נגישות לשירות), התשע"ג 2013.`}
            </StyledLi>
            <StyledLi $margin={20}>
              התאמות הנגישות בוצעו {`עפ"י`} המלצות התקן הישראלי {`(ת"י 5568)`}{" "}
              לנגישות תכנים באינטרנט ברמת AA ומסמך <br></br>WCAG2.0 הבינלאומי.
            </StyledLi>
            <StyledLi $margin={20}>
              הבדיקות נבחנו לתאימות הגבוהה ביותר עבור דפדפן כרום.
            </StyledLi>
            <StyledLi $margin={20}>
              האתר מספק מבנה סמנטי עבור טכנולוגיות מסייעות ותמיכה בדפוס השימוש
              המקובל להפעלה עם מקלדת בעזרת מקשי החיצים, Enter ו- Esc ליציאה
              מתפריטים וחלונות.
            </StyledLi>
            <StyledLi $margin={20}>
              מותאם לתצוגה בדפדפנים הנפוצים ולשימוש בטלפון הסלואלרי.
            </StyledLi>
            <StyledLi $margin={20}>
              לשם קבלת חווית גלישה מיטבית עם תוכנת הקראת מסך, אנו ממליצים לשימוש
              בתוכנת NVDA העדכנית ביותר.
            </StyledLi>
            <StyledLi $margin={20}>
              מסמכים או סרטוני וידאו שעלו לאתר לפני אוקטובר 2017 ייתכן שלא
              נגישים באופן מלא. במידה שנתקלתם במסמך כזה או בסרטון, תוכלו לפנות
              לרכזת נגישות בחברה ואנחנו נדאג להנגיש לכם את המידע.
            </StyledLi>
            <StyledLi $margin={20}>
              מסירת מידע בפורמט נגיש - החברה מעמידה עבור לקוחותיה אפשרות לקבלת
              מידע בפורמטים נגישים. מסירת המידע הינה ללא עלות ומיועדת עבור אנשים
              עם מוגבלות. לפניותומידע בנושא נגישות ניתן ליצור קשר עם רכז הנגישות
              של החברה שפרטיו מופיעים בהמשך ההצהרה.
            </StyledLi>
          </StyledUl>

          <StyledLink
            href="https://a-2-z.co.il/"
            $margin={20}
            $display="block"
            $color="#4C607E"
            $fontSize={18}
          >
            בדיקות ויעוץ הנגישות בוצעו על ידי חברת A2Z נגישות ושיווק באינטרנט
          </StyledLink>
          <StyledHeaderH2 $margin={40}>
            דרכי פנייה לבקשות והצעות לשיפור בנושא נגישות
          </StyledHeaderH2>
          <StyledBody>
            יש לציין כי אנו ממשיכים במאמצים לשפר את נגישות החברה כחלק ממחויבותנו
            לאפשר לכלל האוכלוסייה כולל אנשים עם מוגבלויות לקבל את השרות הנגיש
            ביותר.
          </StyledBody>
          <StyledBody>
            במידה ונתקלת בבעיה או בתקלה כלשהי בנושא הנגישות, נשמח שתעדכן אותנו
            בכך ואנו נעשה כל מאמץ למצוא עבורך פתרון מתאים ולטפל בתקלה בהקדם ככל
            שניתן.
          </StyledBody>
          <StyledH2 $margin={40} $fontWeight={"300"}>
            {`פרטי רכז הנגישות בדלק מוטורס בע"מ`}
          </StyledH2>
          <StyledSmallTextP>שם: שימי עוזון</StyledSmallTextP>
          <StyledBody>
            טלפון:{" "}
            <StyledLink href="tel: 08-9139976" $color="#4C607E" $fontSize={16}>
              08-9139976
            </StyledLink>
          </StyledBody>
          <StyledBody>
            דוא”ל:{" "}
            <StyledLink
              href="mailto: s.uzon@delekmotors.co.il"
              $color="#4C607E"
              $fontSize={16}
            >
              s.uzon@delekmotors.co.il
            </StyledLink>
          </StyledBody>
          <StyledH2 $fontSize="18px" $fontWeight="300">
            פרסום הצהרת הנגישות
          </StyledH2>
          <StyledBody>הצהרת הנגישות עודכנה ביום: 23.06.2024</StyledBody>
        </StyledTextWrapp>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default AccessibilityPage
